<div class="noResults" *ngIf="!resultPresent">
  <div class="searchResultsPresent">
    <div class="searchResultsAccordions">
      <p
        *ngIf="!resultPresent && component.data$ | async as data"
        [innerHTML]="data.content"
      ></p>
    </div>
  </div>
</div>
